"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Check_1 = __importDefault(require("@material-ui/icons/Check"));
var Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
var CrudSimple = __importStar(require("../../../crud-simple"));
var T = __importStar(require("../type"));
var U = __importStar(require("./utils"));
var Authentications = function (_a) {
    var urlPrefix = _a.urlPrefix, dataInterface = _a.dataInterface, _b = _a.options, options = _b === void 0 ? U.defaultAuthenticationMethods : _b, promise = _a.promise, _c = _a.renderType, renderType = _c === void 0 ? U.renderAuthType : _c;
    var dataDef = {
        urlPrefix: urlPrefix,
        fields: [
            {
                name: 'type',
                label: 'Type',
                type: 'select',
                options: options,
                promise: promise,
                render: function (x) { return renderType(x.type); }
            },
            {
                name: 'value',
                label: 'Value',
                type: 'string',
                render: function (x) {
                    return x.type.id === T.AuthenticationMethodType.Password
                        ? x.value.substr(0, 10) + "..."
                        : x.value;
                }
            },
            {
                name: 'isEnabled',
                label: 'Is enabled?',
                type: 'boolean',
                render: function (x) { return (x.isEnabled ? react_1["default"].createElement(Check_1["default"], null) : react_1["default"].createElement(Clear_1["default"], null)); }
            }
        ],
        width: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }
    };
    return react_1["default"].createElement(CrudSimple.Generic.App, { dataDef: dataDef, Data: dataInterface });
};
exports["default"] = Authentications;
